import React from "react";
import { useI18n } from "@/i18n";

const WHATSAPP_DIGITS = "966567028296";
const WHATSAPP_DISPLAY = "+966 56 702 8296";

export default function WhatsAppFloat() {
  const { isRTL, lang } = useI18n();
  const label = lang === "ar" ? "تواصل عبر واتساب" : "Chat on WhatsApp";

  return (
    <a
      href={`https://wa.me/${WHATSAPP_DIGITS}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${label} — ${WHATSAPP_DISPLAY}`}
      data-testid="whatsapp-float"
      className={`fixed bottom-5 ${isRTL ? "left-5" : "right-5"} z-[9990] group`}
    >
      <div className="flex items-center gap-2.5 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/40 hover:shadow-[#25D366]/60 hover:-translate-y-0.5 transition-all px-4 py-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="22"
          height="22"
          fill="currentColor"
          aria-hidden
        >
          <path d="M19.11 4.91A10.94 10.94 0 0 0 12.02 2C6.5 2 2.02 6.48 2.02 12c0 1.93.5 3.74 1.45 5.36L2 22l4.78-1.43A10.94 10.94 0 0 0 12.02 22c5.52 0 10-4.48 10-10 0-2.93-1.14-5.69-2.91-7.09Zm-7.09 15.27c-1.7 0-3.36-.46-4.8-1.34l-.34-.21-2.83.85.85-2.76-.22-.35a8.92 8.92 0 0 1-1.4-4.78c0-4.96 4.04-9 9-9 2.4 0 4.66.94 6.36 2.64s2.64 3.96 2.64 6.36c0 4.96-4.04 9-9 9Zm5.15-6.7c-.28-.14-1.67-.83-1.93-.92-.26-.1-.45-.14-.64.14-.19.28-.74.92-.91 1.11-.17.19-.33.21-.61.07-.28-.14-1.18-.43-2.25-1.39-.83-.74-1.39-1.66-1.55-1.94-.16-.28-.02-.43.12-.57.13-.13.28-.33.42-.5.14-.17.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.64-1.55-.88-2.13-.23-.55-.46-.48-.64-.49h-.55c-.19 0-.5.07-.76.35s-1 .98-1 2.39 1.02 2.78 1.16 2.97c.14.19 2.01 3.07 4.87 4.31.68.29 1.21.47 1.62.6.68.22 1.3.19 1.79.12.55-.08 1.67-.68 1.91-1.34.24-.66.24-1.22.17-1.34-.07-.12-.26-.19-.54-.33Z" />
        </svg>
        <span className="hidden sm:inline text-sm font-semibold">{label}</span>
      </div>
    </a>
  );
}
